module.exports = __webpack_public_path__ + "static/hero-onboarding-baa4a39706908925d42529535c12c3c7.svg";